import { useParams } from 'react-router-dom';
import Button from 'components/Button';
import Plus from 'components/icons/plus';
import useHttpQuery from 'data/firestore/useHttpQuery';
import useManageSipDomains from 'data/hooks/useManageSipDomains';
import {
    StyledCard, Header, HeaderContent, Title, Description,
} from '../styled';
import { EmptyContainer, EmptyMessage, DomainsContainer } from './styled';
import DomainCard from './SipUsersList';

interface SipDomain {
    domainSid: string;
    domainName: string;
    friendlyName?: string;
    voiceUrl?: string;
}

const SipDomains = () => {
    const { agentId = '' } = useParams();
    const { create } = useManageSipDomains({ agentId });

    const { data: domains = [], isLoading } = useHttpQuery<SipDomain[]>({
        pathname: `/agents/${agentId}/sip-domains`,
        key: ['sip-domains', agentId],
        queryOptions: { enabled: Boolean(agentId) },
    });

    const hasDomain = domains.length > 0;

    return (
        <StyledCard>
            <Header>
                <HeaderContent>
                    <Title>Voice Connections</Title>
                    <Description>
                        Set up where your Voxity phones connect
                    </Description>
                </HeaderContent>
                {!isLoading && !hasDomain && (
                    <Button
                        variant="outline-brand"
                        size="medium"
                        borderRadius="semi-rounded"
                        onClick={create}
                    >
                        <Plus />
                        Create SIP Domain
                    </Button>
                )}
            </Header>
            {!isLoading && !hasDomain && (
                <EmptyContainer>
                    <EmptyMessage>
                        No SIP domain configured yet. Create one to get started.
                    </EmptyMessage>
                </EmptyContainer>
            )}
            {hasDomain && (
                <DomainsContainer>
                    {domains.map((domain) => (
                        <DomainCard key={domain.domainSid} domain={domain} />
                    ))}
                </DomainsContainer>
            )}
        </StyledCard>
    );
};

export default SipDomains;
